import {Component, OnInit, Input, OnChanges, SimpleChanges, forwardRef} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder } from '@angular/forms';
import { AbwDatasourceColumn, Model_WorkflowComponent, TYPE_DEFAULT_VALUE, FONCTION_WORKFLOW_COMPONENT_OPTIONS, Model_VariableEnvironnement } from 'src/app/app.models';

@Component({
    selector: 'abw-datasource-columns-inputgrid-mapping',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatasourceColumnsInputGridMappingComponent),
            multi: true
        }
      ],
    templateUrl: './datasource-columns-inputgrid-mapping.component.html',
    styleUrls: ['./datasource-columns-inputgrid-mapping.component.scss'],
})
export class DatasourceColumnsInputGridMappingComponent implements OnChanges {
    @Input() datasourceColumns: AbwDatasourceColumn[];
    @Input() gridColumns: Model_WorkflowComponent[];
    @Input() variables: Model_VariableEnvironnement[] = [];

    displayedColumns = ['PRIMARY_KEY_DATASOURCE', 'DATASOURCE_COLUMN', 'TYPE_DEFAULT_VALUE', 'DEFAULT_VALUE', 'ACTIONS'];
    dataSource = new MatTableDataSource<FormGroup>();
    PRIMARY_KEY_DATASOURCE = 0;
    operators: { VALUE: any, DISPLAY: string }[] = [
        { VALUE: TYPE_DEFAULT_VALUE.CONSTANT, DISPLAY: 'Constante' },
        { VALUE: TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD, DISPLAY: 'Champ de la grille' },
        //{ VALUE: TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE, DISPLAY: 'Variable d\'environnement' },
        { VALUE: TYPE_DEFAULT_VALUE.FONCTION, DISPLAY: 'Fonction' },
    ];
    TYPE_DEFAULT_VALUE = TYPE_DEFAULT_VALUE;
    FONCTION_WORKFLOW_COMPONENT_OPTIONS = FONCTION_WORKFLOW_COMPONENT_OPTIONS;


    constructor(
        private _formBuilder: FormBuilder,
    ) {
    } 

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.datasourceColumns && !!changes.datasourceColumns.currentValue) {
            this.dataSource.data = this.datasourceColumns.map(c => {
                return new FormGroup({ DATASOURCE_COLUMN: new FormControl(c.name), TYPE_DEFAULT_VALUE: new FormControl(TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD), DEFAULT_VALUE: new FormControl() });
            });
        }
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: { PRIMARY_KEY: boolean, DEFAULT_VALUE: string, TYPE_DEFAULT_VALUE: any, DATASOURCE_COLUMN: string }[]) {
        if (!!value) {
            this.PRIMARY_KEY_DATASOURCE = value.findIndex(v => v.PRIMARY_KEY === true);
            this.dataSource.data = value.map(c => {
                return new FormGroup({ DATASOURCE_COLUMN: new FormControl(c.DATASOURCE_COLUMN), TYPE_DEFAULT_VALUE: new FormControl(c.TYPE_DEFAULT_VALUE), DEFAULT_VALUE: new FormControl(c.DEFAULT_VALUE) });
            });
        }
    }

	onValueChanged(rowChangeEvent?: { index: number, value: string }) {
        if (!!rowChangeEvent) {
            this.dataSource.data[rowChangeEvent.index].controls.DEFAULT_VALUE.patchValue(rowChangeEvent.value);
        }
        const rows = this.dataSource.data;
        const value = rows.map(formGroup => formGroup.value);
        value.forEach((row, index, rows) => {
            rows[index].PRIMARY_KEY = this.PRIMARY_KEY_DATASOURCE == index;
        })
	  	this.propagateChange(value);
	}

    addRow() {
        const rows = this.dataSource.data;
        const rowFormGroup = this._formBuilder.group({
            DATASOURCE_COLUMN: [this.datasourceColumns.length > 0 ? this.datasourceColumns[0].name : null],
            TYPE_DEFAULT_VALUE: [this.operators.length > 0 ? this.operators[0].VALUE : null],
            DEFAULT_VALUE: [null]
        });
        rows.push(rowFormGroup);
        this.dataSource.data = rows;
        this.onValueChanged();
    }

    removeRow(index: number) {
        const rows = this.dataSource.data;
        rows.splice(index, 1);
        this.dataSource.data = rows;
        this.onValueChanged();
    }
}